// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/default-blue-white.css
// module id = 690
// module chunks = 1